import ListingFieldsRequiredVisibleInfoProvider from './ListingFieldsRequiredVisibleInfo.provider';

export default ListingFieldsRequiredVisibleInfoProvider;
